import React, { useState, useEffect } from "react";
import axios from "axios";
import "./EnrollForm.css";
import { API_BASE_URL } from "../config";

const EnrollForm = ({ course, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: course?.title || course?.name || "",
    location: "",
    address: "",
    agree: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (course?.title || course?.name) {
      setFormData((prev) => ({
        ...prev,
        course: course.title || course.name,
      }));
    }
  }, [course]);

  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required";
    if (!formData.location) newErrors.location = "Select a location";
    if (!formData.address.trim()) newErrors.address = "Address is required";
    if (!formData.agree) newErrors.agree = "Agreement required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* INPUT CHANGE */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  /* SUBMIT */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate() || loading) return;
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/enrollments`, formData);
      alert("✅ Enrollment submitted successfully!");
      onClose();
    } catch (err) {
      console.error("Enrollment Error:", err);
      alert("⚠ Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!course) return null;

  return (
    <div className="ef-modal-overlay">
      <div className="ef-modal-container">
        <button className="ef-close-btn" onClick={onClose}>&times;</button>
        
        <div className="ef-layout">
          {/* 1. COURSE CONTEXT SIDE */}
          <div className="ef-context">
            <div className="ef-badge">Professional Certification</div>
            {course?.image && (
              <div className="ef-image-wrapper">
                <img src={`${API_BASE_URL}${course.image}`} alt={course.title} />
              </div>
            )}
            <div className="ef-meta">
              <h3>{course.title || course.name}</h3>
              <p className="ef-description">{course.description || 'Master executive UAV operations with DGCA-approved training and industry certifications.'}</p>
              <div className="ef-trust-points">
                <span>✓ Comprehensive Curriculum</span>
                <span>✓ Industry Recognized Certificate</span>
                <span>✓ Practical Flight Training</span>
              </div>
            </div>
          </div>

          {/* 2. FORM ENTRY SIDE */}
          <div className="ef-form-side">
            <h2 className="ef-title">Enroll Now</h2>
            <p className="ef-subtitle">Register your details to secure your training slot.</p>

            <form onSubmit={handleSubmit} className="ef-main-form">
              <div className="ef-form-grid">
                <div className="ef-input-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    className={errors.name ? "ef-error" : ""}
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="ef-input-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="example@email.com"
                    className={errors.email ? "ef-error" : ""}
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="ef-input-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="10-digit number"
                    className={errors.phone ? "ef-error" : ""}
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="ef-input-group">
                  <label>Training Hub</label>
                  <select
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    className={errors.location ? "ef-error" : ""}
                  >
                    <option value="">-- Select Hub --</option>
                    <option value="Namakkal">Namakkal (Main Hub)</option>
                    <option value="Bangalore">Bangalore</option>
                  </select>
                </div>
              </div>

              <div className="ef-input-group full">
                <label>Current Address</label>
                <textarea
                  name="address"
                  placeholder="Street, City, Pin..."
                  className={errors.address ? "ef-error" : ""}
                  value={formData.address}
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="ef-checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="agree"
                    checked={formData.agree}
                    onChange={handleChange}
                  />
                  <span>I agree to the terms & confirm I am above 18 years.</span>
                </label>
                {errors.agree && <span className="ef-err-msg">{errors.agree}</span>}
              </div>

              <button type="submit" className="ef-submit-btn" disabled={loading}>
                {loading ? "Processing..." : "Confirm Enrollment"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrollForm;
